import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=ab77a85a&scoped=true"
import script from "./NoticeForm.vue?vue&type=script&lang=js"
export * from "./NoticeForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeForm.vue?vue&type=style&index=0&id=ab77a85a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab77a85a",
  null
  
)

export default component.exports